import React, { useCallback, useContext, useEffect, useState } from "react";
import "./SubAdminAdd.css";
import { SidebarContext } from "../../../context/SidebarContext";
import SectionMenuLeft from "../../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import { ToastContainer, toast } from "react-toastify";
import { config } from "../../../config.js";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../../components/CustomSelect/CustomSelect.jsx";
import { LuArrowLeft } from "react-icons/lu";

function SubAdminAdd() {
  const navigate = useNavigate();
  const { isSidebar } = useContext(SidebarContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isCityFetching, setIsCityFetching] = useState(false);
  const [cityList, setCityList] = useState([]);

  const [subAdmin, setSubAdmin] = useState({
    name: "",
    username: "",
    email: "",
    city: "",
    password: "",
    active: true,
  });

  const fetchCities = useCallback(async () => {
    setIsCityFetching(true);
    try {
      const response = await fetch(`${config.backEndBaseUrl}city/get`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch cities: ${response.status}`);
      }

      const data = await response.json();
      setCityList(data.cities || []);
    } catch (error) {
      toast.error("Failed to fetch cities");
    } finally {
      setIsCityFetching(false);
    }
  }, []);

  useEffect(() => {
    fetchCities();
  }, [fetchCities]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSubAdmin((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    // console.log(subAdmin)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}sub-admin/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
          body: JSON.stringify(subAdmin),
        },
      );

      const result = await response.json();

      if (response.ok && result.status) {
        toast.success("Sub-admin added successfully!");
        setTimeout(() => {
          navigate("/admin/sub");
        }, 1000);
      } else {
        toast.error(result.message || "Failed to add sub-admin");
      }
    } catch (error) {
      console.error("Error adding sub-admin:", error);
      toast.error("Error adding sub-admin");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />
            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
              >
                <div className="main-content-inner">
                  <div className="wg-box wg-box-container">
                    <ToastContainer />

                    <form
                      className="form-new-product form-style-1"
                      onSubmit={handleSubmit}
                    >
                      <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                        <div className="flex items-center gap-3">
                          <button
                            className="back-btn flex items-center gap-2"
                            onClick={() => navigate(-1)}
                          >
                            <LuArrowLeft size={16} />
                            {/* <span>Back</span> */}
                          </button>

                          <h5 className="fare-heading">Add Sub-Admin</h5>
                        </div>
                      </div>
                      <fieldset>
                        <div className="body-title">Name</div>
                        <input
                          type="text"
                          name="name"
                          value={subAdmin.name}
                          onChange={handleChange}
                          placeholder="name"
                          required
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">User Name</div>
                        <input
                          type="text"
                          name="username"
                          value={subAdmin.username}
                          onChange={handleChange}
                          placeholder="username"
                          required
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">Email</div>
                        <input
                          type="email"
                          name="email"
                          value={subAdmin.email}
                          onChange={handleChange}
                          placeholder="Email"
                          required
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">City</div>
                        {/* <input
                                                    type="text"
                                                    name="city"
                                                    value={subAdmin.city}
                                                    onChange={handleChange}
                                                    placeholder="City"
                                                /> */}

                        <CustomSelect
                          options={
                            cityList?.map((c) => c.city).filter(Boolean) || []
                          }
                          value={subAdmin.city}
                          placeholder="City"
                          onChange={(val) =>
                            handleChange({
                              target: {
                                name: "city",
                                value: val.toLowerCase(),
                              },
                            })
                          }
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">Password</div>
                        <input
                          type="password"
                          name="password"
                          value={subAdmin.password}
                          onChange={handleChange}
                          placeholder="Enter new password"
                        />
                      </fieldset>

                      <fieldset>
                        <div className="body-title">Active</div>
                        <label className="switch">
                          <input
                            type="checkbox"
                            name="active"
                            checked={subAdmin.active}
                            onChange={handleChange}
                          />
                          <span className="slider round"></span>
                        </label>
                      </fieldset>

                      <div className="subBtnCon">
                        <button
                          type="submit"
                          className="btn"
                          disabled={isLoading}
                        >
                          {isLoading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubAdminAdd;
